import user from './config/user';
import home from './config/home';
import capt from './config/capt';
import loginHome from './config/loginHome';
import loginWindow from './config/loginWindow';
import game from './config/game';
import roleInfo from './config/roleInfo';
import pay from './config/pay';
import passWord from './config/passWord';
import message from './config/message';
import operation from './config/operation';
import auth from './config/auth';
import IdentityAuth from './config/IdentityAuth';
import task from './config/task';
import credit from './config/credit';
import userTrumpet from './config/userTrumpet';
import coupon from './config/coupon';
import commonity from './config/commonity';
import live from './config/live';
import liveStreaming from './config/liveStreaming';
import liveBroadRoom from './config/liveBroadRoom';
import competition from './config/competition';
import members from './config/members';
import shortVideo from './config/shortVideo';
import collection from './config/collection';
import tradingBank from './config/tradingBank';
import tradingBankMybox from './config/tradingBankMybox';
import competitionEvent from './config/competitionEvent';
import commonityFeedback from './config/commonityFeedback';
import voice from './voice';
import voiceLive from './voice/voiceLive';
import userMember from './config/userMember';
import signChat from './signChat';
import realGame from './config/realGame';
import margin from './config/margin';
import domainFn from './defence';
import pkConfig from './live/pkConfig';
import connect from './live/connect';
import guard from './live/guard';
import tradingReconsituition from './config/tradingReconsituition';
import giftReward from './config/giftReward';
import training from './config/training';
import raffle from './config/raffle';
import shopping from './config/shopping';
import pass from './config/pass';
import liveRaffle from './config/liveRaffle';
import voiceCommunity from './voiceCommunity';
import voiceCommunityRoom from './voiceCommunity/room';
import voiceCommunitysdkIndex from './voiceCommunity/sdkIndex';
import voiceCommunitySdkRoom from './voiceCommunity/sdkRoom';
import playful from './prefecture/playful';
import { resolveApiUrl } from './showApiDirect';
import monthCard from './config/pcMonthCard';

import env from './env';

// const { envConfig, proxyCurrent } = require('../../config/env.js');

// 环信 appkey / 声网 / 验签：由各环境 .env 注入（见 REACT_APP_*）
const webIm = process.env.REACT_APP_WEB_IM ?? '';
const agoraAppId = process.env.REACT_APP_AGORA_APP_ID ?? '';
const liveAgoraAppId = process.env.REACT_APP_LIVE_AGORA_APP_ID ?? '';
const signkey = process.env.REACT_APP_SIGNKEY ?? '';
const newsignkey = process.env.REACT_APP_NEWSIGNKEY ?? ''; // 380 新验签
let transaction = `//charge-test.${domainFn.domain}/#/dealIndex`; // 交易行pc地址
let gameServer = '//server-test.drawjy.com/timezone'; // 游戏服务器时间
let sdkAppIdTencent, sdkSecretKeyTencent;

if (env.envConfig === 'pre') {
  transaction = `//charge-pre.${domainFn.domain}/#/dealIndex`; // 交易行pc地址
  gameServer = '//cdn-pre.bwljgy.cn/timezone';
} else if (env.envConfig === 'production') {
  transaction = `//charge.${domainFn.domain}/#/dealIndex`; // 交易行pc地址
  gameServer = '//server.zqdjy.cn/timezone';
} else {
  transaction = `//charge-test.${domainFn.domain}/#/dealIndex`; // 交易行pc地址
  gameServer = '//server-test.drawjy.com/timezone';
  sdkAppIdTencent = '1600104270';
  sdkSecretKeyTencent = 'b134c017b49407359855faec4f6134d94e1f0c72f6bceef2aca92efb148f10e4';
}

let api: any = {
  user, // 用户
  home, // 首页 推荐页等
  capt, // 图像验证码
  loginHome, // 登录相关
  loginWindow, // 新版登录窗口内
  game, // 游戏相关
  roleInfo, // 角色信息
  Pay: pay, // 支付信息
  PassWord: passWord, // 验证密码
  UploadImage: {
    // 用户上传图片
    UploadImg: `/userApi/v1/UserInfo/head_img_upload`
  },
  Message: message, // 消息中心
  operation, // 埋点
  auth, // 实名认证
  IdentityAuth, // 身份认证
  task, // 任务
  credit, // 信用分
  userTrumpet, // 小号编辑
  coupon, // 优惠券
  commonity: {
    // 社区
    ...commonity,
    // 社区用户行为埋点 ----- 刘阳
    forumFootprint: `/footprintApi/api/Forum/footprint`
    // forumFootprint: `http://anvj.dhsftest.xqhuyu.com/api/Forum/footprint`,
  },
  // 直播
  live: {
    // 环信的appkey
    appkey: webIm,
    ...live,
    // 直播中心相关
    ...liveStreaming,
    ...pkConfig,
    ...guard,
    ...connect,
    liveAgoraAppId
  },
  liveBroadRoom: {
    ...liveBroadRoom,
    // 直播埋点
    // liveFootprint: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/User/footprint`,
    // 直播埋点改 -- 刘阳
    // liveFootprint: `${httpCommonityRecordApi}${liveOperationUrl}/Live/footprint`
    liveFootprint: `/footprintApi/api/Live/footprint`
  },
  competition, // 赛事
  members, // 会员
  shortVideo, // 短视频
  collection, // 数据收集
  transaction,
  tradingBank,
  tradingBankMybox,
  competitionEvent,
  commonityFeedback,
  voice: {
    ...voice,
    agoraAppId
  },
  voiceLive,
  userMember,
  signChat,
  signkey,
  newsignkey,
  realGame,
  margin,
  tradingReconsituition,
  giftReward,
  training,
  raffle,
  gameServer,
  shopping,
  pass,
  liveRaffle,
  voiceCommunity: {
    ...voiceCommunity,
    ...voiceCommunityRoom,
    sdkAppId: sdkAppIdTencent,
    sdkSecretKey: sdkSecretKeyTencent
  },
  voiceCommunityRoom,
  voiceCommunitySdk: {
    ...voiceCommunitysdkIndex,
    ...voiceCommunitySdkRoom,
    sdkAppId: sdkAppIdTencent,
    sdkSecretKey: sdkSecretKeyTencent
  },
  playful,
  monthCard
};

// 发布到环境
api = factory(api);
function factory(apis: any) {
  for (const key in apis) {
    if (Object.prototype.hasOwnProperty.call(apis, key)) {
      const element = apis[key];
      if (Object.prototype.toString.call(element) === '[object Object]') {
        apis[key] = factory(element);
      } else {
        apis[key] = resolveApiUrl(element);
      }
    }
  }
  return apis;
}

export default api;
